import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Router, { RouteConfig } from 'vue-router'

import { allowRefreshOrShare, setLoading, setShareInfo, setBaiduTrack } from '@utils/index'

import categorylistRouting from './pages/category/category-routing'
import userRouting from './pages/user/user-routing'
import shopRouting from './pages/shop/shop.routing'
import searchRouting from './pages/search/search-routing';
import homeRouting from './pages/home/home-routing'
import promotionRouting from './pages/promotion/promotion-routing'
import cityChooseRouting from './pages/city-choose/city-choose-routing'
import growthSouvenirRouting from "./pages/growthSouvenir/router/index"
import scenicTourismRouting from "./pages/scenicTourism/router/index"

import { indexOf } from 'lodash'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave'
])

Vue.use(Router)

const routes: RouteConfig[] = [
  userRouting,
  categorylistRouting,
  shopRouting,
  searchRouting,
  homeRouting,
  promotionRouting,
  cityChooseRouting,
  growthSouvenirRouting,
  scenicTourismRouting,
  {
    beforeEnter: () => {
      location.replace('//w.cekid.com/404.html')
    },
    path: '*'
  }
]

const scrollBehavior = function (to: any, from: any, savedPosition: any) {
  if (savedPosition) {
    return savedPosition
  } else {
    const position: any = {}
    if (to.hash) {
      position.selector = to.hash
      if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
        return position
      }
      return false
    }
    return new Promise(resolve => {
      if (to.matched.some((m: any) => !m.meta.scrollTo)) {
        position.x = 0
        position.y = 0
      }
      resolve(position)
    })
  }
}

const router = new Router({
  base: '/h5',
  mode: 'history',
  routes,
  scrollBehavior
})
/**
 * 保存页面的路由 路由name
 */
const keepAliveRouter: any = ['category']

router.beforeEach((to: any, from: any, next) => {
  /**==============  页面数据保存 start  =============== **/
  const toPageIndex = indexOf(keepAliveRouter, to && to.name)
  if (toPageIndex > -1) {
    to.meta.keepAlive = true
  } else {
    to.meta.keepAlive = false
  }

  /**==============  页面数据保存 end  =============== **/
  setLoading()
  /**==============  页面刷新分享&设置 start  =============== **/
  let canShare = true
  let canRefresh = true
  if (to && to.query) {
    const query = to.query
    if (query.cmd === 'share' && query.sharetype === '0') {
      canShare = false
    }
    if (query.refresh === 'no') {
      canRefresh = false
    }
  }
  allowRefreshOrShare(canRefresh, canShare)
  /**==============  页面刷新分享&设置 end  =============== **/
  next()
})
router.afterEach(() => {
  setBaiduTrack()
  setShareInfo()
  setLoading(false)
})

export default router
